function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { Component } from 'react';
import MetaTags from 'react-meta-tags';
import { translate } from '../../utils/helpers';
import { SITE_NAME } from '../../utils/constant';

var CertificationsMetaTags = /*#__PURE__*/function (_Component) {
  _inherits(CertificationsMetaTags, _Component);

  var _super = _createSuper(CertificationsMetaTags);

  function CertificationsMetaTags() {
    _classCallCheck(this, CertificationsMetaTags);

    return _super.apply(this, arguments);
  }

  _createClass(CertificationsMetaTags, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(MetaTags, null, /*#__PURE__*/React.createElement("title", null, translate('All certifications', 'Toutes les certifications'), " \u2013\xA0", SITE_NAME), /*#__PURE__*/React.createElement("meta", {
        name: "description",
        content: ""
      }), /*#__PURE__*/React.createElement("meta", {
        property: "og:title",
        content: "".concat(translate('All certifications', 'Toutes les certifications'), " \u2013 ").concat(SITE_NAME)
      }), /*#__PURE__*/React.createElement("meta", {
        property: "og:description",
        content: ""
      }), /*#__PURE__*/React.createElement("meta", {
        property: "og:type",
        content: 'product'
      }), /*#__PURE__*/React.createElement("meta", {
        property: "og:image",
        content: ""
      }), /*#__PURE__*/React.createElement("meta", {
        property: "og:url",
        content: window.location.href
      }), /*#__PURE__*/React.createElement("meta", {
        name: "twitter:title",
        content: "".concat(translate('All certifications', 'Toutes les certifications'), " \u2013 ").concat(SITE_NAME)
      }), /*#__PURE__*/React.createElement("meta", {
        name: "twitter:description",
        content: ""
      }), /*#__PURE__*/React.createElement("meta", {
        name: "twitter:image",
        content: ""
      }));
    }
  }]);

  return CertificationsMetaTags;
}(Component);

export default CertificationsMetaTags;